import { Truck } from "@phosphor-icons/react";

export const DispatchDetailsCard = ({ order, canUpdate, dispatch, setDispatch, saveDispatch, saving }) => {
  const dispatchField = (key, label, type = "text") => (
    <div>
      <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      <input data-testid={`dispatch-${key}-input`} type={type} value={dispatch[key] || ""}
        onChange={(e) => setDispatch((d) => ({ ...d, [key]: e.target.value }))}
        className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
    </div>
  );

  return (
    <div className="rounded-md border border-slate-200 bg-white p-5">
      <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
        <Truck size={18} weight="duotone" /> Dispatch Details
      </h2>
      {canUpdate ? (
        <div className="mt-4 space-y-4">
          <div className="grid gap-3 sm:grid-cols-2">
            {dispatchField("dispatch_date", "Dispatch Date", "date")}
            {dispatchField("transporter_name", "Transporter Name")}
            {dispatchField("vehicle_number", "Vehicle Number")}
            {dispatchField("lr_number", "LR / Tracking Number")}
            {dispatchField("driver_mobile", "Driver Mobile", "tel")}
          </div>
          <button data-testid="save-dispatch-button" onClick={saveDispatch} disabled={saving}
            className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-100 disabled:opacity-60">
            Save dispatch details
          </button>
        </div>
      ) : order.dispatch ? (
        <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-2">
          <div><dt className="text-xs uppercase tracking-wider text-slate-500">Dispatch Date</dt><dd className="font-medium">{order.dispatch.dispatch_date}</dd></div>
          <div><dt className="text-xs uppercase tracking-wider text-slate-500">Transporter</dt><dd className="font-medium">{order.dispatch.transporter_name}</dd></div>
          <div><dt className="text-xs uppercase tracking-wider text-slate-500">Vehicle No</dt><dd className="font-mono font-medium">{order.dispatch.vehicle_number}</dd></div>
          <div><dt className="text-xs uppercase tracking-wider text-slate-500">LR No</dt><dd className="font-mono font-medium">{order.dispatch.lr_number}</dd></div>
          <div><dt className="text-xs uppercase tracking-wider text-slate-500">Driver Mobile</dt><dd className="font-mono font-medium">{order.dispatch.driver_mobile || "—"}</dd></div>
        </dl>
      ) : (
        <p className="mt-3 text-sm text-slate-400">Not dispatched yet.</p>
      )}
    </div>
  );
};
